import { MediaType } from '../../types/media/media.type';
import { VideoSource } from '../../types/media/video-source.type';
import { Image } from '../image/image.model';
import { IMediaItem } from './media-item.model';

export interface IMediaVideoConfig {
    videoSource: VideoSource;
    title: string;
    url: string;
    thumbnail?: Image;
    type?: MediaType;
}

export class MediaVideo implements IMediaItem {
    videoSource: VideoSource;
    title: string;
    url: string;
    thumbnail?: Image;
    type?: MediaType;

    constructor(config: IMediaVideoConfig) {
        this.videoSource = config.videoSource;
        this.title = config.title;
        this.url = config.url;
        this.thumbnail = config.thumbnail;
        this.type = config.type ?? 'video';
    }
}
